module.exports = __webpack_public_path__ + "img/des-8.7fc038e1.jpg";